import React from 'react';
import { Facebook, Twitter, Linkedin, Mail, BookOpen, Heart } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#064635] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex items-center gap-3 mb-8">
          <img
            src="/logo-icon.png"
            alt=""
            className="h-9 sm:h-11"
          />
          <div>
            <h2 className="text-lg sm:text-xl font-bold text-white">Echoes of Ibadan</h2>
            <p className="text-xs sm:text-sm text-[#D4AF37] tracking-wider uppercase">Scholarly Archive</p>
          </div>
        </div>

        <div className="bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-lg p-6 mb-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="text-center sm:text-left">
              <h3 className="text-lg font-semibold text-[#D4AF37] mb-1">Support This Archive</h3>
              <p className="text-sm text-gray-300">
                Help preserve Yoruba scholarly heritage for future generations
              </p>
            </div>
            <Link
              to="/support"
              className="bg-[#D4AF37] text-[#064635] px-6 py-3 rounded-lg font-semibold
                       hover:bg-opacity-90 transition-colors duration-200 flex items-center gap-2 whitespace-nowrap"
            >
              <Heart className="h-5 w-5" />
              Donate Now
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#D4AF37]">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-[#D4AF37] transition">Home</Link></li>
              <li><Link to="/publications" className="hover:text-[#D4AF37] transition">Publications</Link></li>
              <li><Link to="/about" className="hover:text-[#D4AF37] transition">About</Link></li>
              <li><Link to="/support" className="hover:text-[#D4AF37] transition">Support</Link></li>
              <li><Link to="/contact" className="hover:text-[#D4AF37] transition">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#D4AF37]">Publication Categories</h3>
            <ul className="space-y-2">
              <li><Link to="/publications/category/foundational-histories" className="hover:text-[#D4AF37] transition">Foundational Histories</Link></li>
              <li><Link to="/publications/category/governance" className="hover:text-[#D4AF37] transition">Governance & Leadership</Link></li>
              <li><Link to="/publications/category/culture" className="hover:text-[#D4AF37] transition">Culture & Heritage</Link></li>
              <li><Link to="/publications/category/urbanization" className="hover:text-[#D4AF37] transition">Urbanization</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#D4AF37]">Archive Info</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <BookOpen className="h-5 w-5 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                <span>72+ Publications Available</span>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="h-5 w-5 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                <span className="break-all text-sm sm:text-base">lolatomori@yahoo.com</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#D4AF37]">Connect</h3>
            <div className="flex space-x-4 mb-6">
              <a href="#" className="hover:text-[#D4AF37] transition">
                <Facebook className="h-6 w-6" />
              </a>
              <a href="#" className="hover:text-[#D4AF37] transition">
                <Twitter className="h-6 w-6" />
              </a>
              <a href="#" className="hover:text-[#D4AF37] transition">
                <Linkedin className="h-6 w-6" />
              </a>
            </div>
            <p className="text-sm text-gray-300">
              A digital archive preserving the scholarly works of ESV. Tomori Moshood Adijolola
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 text-center text-gray-300">
          <p className="mb-3 text-sm sm:text-base">© 2025 Echoes of Ibadan. All rights reserved.</p>
          <div className="text-xs sm:text-sm space-y-1">
            <p className="font-medium text-[#D4AF37]">Published by MACOS Urban Management Consultants</p>
            <p className="px-4">P.O. Box 7051, Secretariat Post Office, Ibadan, Nigeria</p>
            <p className="px-4 break-words">Contact: lolatomori@yahoo.com | +234 803 726 0702</p>
          </div>
        </div>
      </div>
    </footer>
  );
}